import {CHAT_MODERATOR_REASON_MAX_LENGTH, CHAT_REJECTION_REASONS} from '../../configs/matchChat';

/**
 * Причины отказа, которые ставит сам клиент, а не сервер: сервер не
 * подтвердил прием сообщения (обрыв связи, переподключение) — его судьба
 * неизвестна, и висеть «отправляется…» вечно оно не должно.
 */
export const CHAT_CLIENT_REJECTION_REASONS = {
  NO_RESPONSE: 'no_response',
};

const REJECTION_TEXTS = {
  [CHAT_REJECTION_REASONS.MODERATION_REJECTED]: 'Отклонено модератором',
  [CHAT_REJECTION_REASONS.CHAT_PAUSED]: 'Чат временно недоступен — сообщение не доставлено',
  [CHAT_REJECTION_REASONS.MODERATION_TIMEOUT]: 'Модератор не ответил — сообщение не доставлено',
  [CHAT_REJECTION_REASONS.INVALID]: 'Сообщение пустое, слишком длинное или со служебными символами',
  [CHAT_REJECTION_REASONS.PREFILTER_LINK]: 'Ссылки в чате матча запрещены',
  [CHAT_REJECTION_REASONS.PREFILTER_SECRET]: 'Похоже на ключ или пароль — такое в чат не отправляется',
  [CHAT_CLIENT_REJECTION_REASONS.NO_RESPONSE]: 'Сервер не ответил — сообщение не доставлено',
};

const DEFAULT_REJECTION_TEXT = 'Сообщение не доставлено';

/**
 * Пояснение модератора в том виде, в каком его можно показать: строка без
 * пробелов по краям и не длиннее CHAT_MODERATOR_REASON_MAX_LENGTH. Его пишет
 * агент, читающий недоверенный чат, поэтому сервер его обрезает — клиент
 * обрезает еще раз, не доверяя чужой реализации. Не строка — null.
 */
export const normalizeModeratorReason = (moderatorReason) => {
  if (typeof moderatorReason !== 'string') return null;
  const trimmed = moderatorReason.trim().slice(0, CHAT_MODERATOR_REASON_MAX_LENGTH);
  return trimmed || null;
};

/**
 * Текст отказа для отправителя — по причине из CHAT_MESSAGE_REJECTED
 * (CHAT_REJECTION_REASONS в configs/matchChat.js) или по клиентской причине.
 *
 * @param {string} reason
 * @param {Object} [details]
 * @param {string|null} [details.moderatorReason] - пояснение модератора
 * @param {number|null} [details.retryAfterMs] - через сколько можно повторить
 * @returns {string}
 */
export const getChatRejectionText = (reason, {moderatorReason, retryAfterMs} = {}) => {
  if (reason === CHAT_REJECTION_REASONS.MODERATION_REJECTED) {
    const explanation = normalizeModeratorReason(moderatorReason);
    return explanation
      ? `${REJECTION_TEXTS[reason]}: ${explanation}`
      : REJECTION_TEXTS[reason];
  }
  if (reason === CHAT_REJECTION_REASONS.RATE_LIMITED) {
    // Без срока — упор в число сообщений на проверке: ждать нужно вердиктов,
    // а не времени (см. checkChatRateLimit)
    if (typeof retryAfterMs === 'number' && Number.isFinite(retryAfterMs) && retryAfterMs > 0) {
      return `Слишком часто — повторите через ${Math.ceil(retryAfterMs / 1000)} сек`;
    }
    return 'Слишком много сообщений на проверке — дождитесь решения модератора';
  }
  return REJECTION_TEXTS[reason] || DEFAULT_REJECTION_TEXT;
};
